export default __webpack_public_path__ + "static/media/1454.5b89a653.png";